import React from "react";
import { useSelector } from "react-redux";
import Product from "./Product";

export default function ProductContainer() {
  const products = useSelector((state) => state.productStore);

  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8">
      {products.map(({ name, price, availableStock }, index) => (
        <Product
          key={index}
          name={name}
          price={price}
          availableStock={availableStock}
        />
      ))}
    </div>
  );
}
